module.exports = __webpack_public_path__ + "static/media/goldStar.62d04603.svg";